import React, { useContext } from "react";
import AccountPage from "./AccountPage.jsx";
import { Box, CssBaseline, IconButton, Menu, styled, Toolbar, Typography, useTheme } from "@mui/material";
import { ThemeContext } from "../controller/context/ThemeContext.js";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import MuiAppBar from '@mui/material/AppBar';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe('pk_live_51QBHipA8XwBIdmYf3FWwuUluzpjmo15S3m4YWO2RsKyYxEezAllP9b2B7pML8taK18nfT86q0lgqa4Ah3vyPoFIO00kr7TRsjA');


const AppBar = styled(MuiAppBar, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      boxShadow:'none',
  
      backgroundImage: 'url("https://www.transparenttextures.com/patterns/always-grey.png")',
      backgroundSize: 'repeat',
      background:theme.palette.appbar.backgroundColor,
      color: '#346152',
   
    })
  );
  


export const Account = ()=>{
    const { themeMode, toggleTheme } = useContext(ThemeContext);
    const theme = useTheme();
    return (
    <>
     <Elements stripe={stripePromise}> 
    <AccountPage/>
    </Elements> 
    </>)
}